import firebase from 'firebase';

firebase.initializeApp(process.env.firebaseConfig);

export default {
  database: firebase.database(),
};



// WEBPACK FOOTER //
// ./src/services/firebase.js